import styled from 'styled-components'
import { Icon } from '@navent-jobs/ui-kit/components/icon'
import { Sidebar } from '../../sidebar'

export const LoaderWrapper = styled('div')`
  background: rgba(255, 255, 255, 0.6);
  position: absolute;
  z-index: 20;
  pointer-events: none;
  touch-action: none;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  min-width: 100%;
  min-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`

const FilterSidebarComponent = styled('div')`
  width: 100%;
  max-width: 100%;
  height: 100%;
  position: relative;
`

export const LayerOneFilterSidebarComponent = styled(FilterSidebarComponent)`
  overflow: auto;
  max-height: calc(100% - 112px);
`

export const TagFilterSidebarComponent = styled('ul')`
  margin: 11px 0px 4px 0px;
  padding: 0;
  list-style-type: none;
  text-align: justify;

  & > li {
    display: inline-block;
  }
`

export const LayerTwoFilterSidebarComponent = styled(FilterSidebarComponent)`
  overflow: auto;
  max-height: calc(100% - 56px);
  padding: 0px 16px;
`

const SidebarTitle = styled('h3')`
  font-weight: 600;
  font-size: 18px;
  height: 56px;
  color: ${({ theme }) => theme.colors.secondary.normal};
  margin: 0px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  background-color: white;
`

export const LayerTwoSidebarTitle = styled(SidebarTitle)`
  padding: 0px 16px 0px 50px;
`

export const LayerOneSidebarFooter = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 10px 0 0 0;
  margin: 0 0 -6px 0;
`

export const SidebarMenu = styled(Sidebar)`
  width: 100%;
  height: 100%;
  background-color: #ffe600;
  position: fixed;
  top: 0;
  ${({ position }) => (position === 'right' ? 'left: 0;' : 'right: 0;')}
  transform: translate3d(-100%, 0, 0);
  transition: transform 0.3s cubic-bezier(0, 0.52, 0, 1);
`

export const RemoveFilter = styled('button')`
  border: 0;
  padding: 0;
  background: transparent;
  display: flex;
  justify-content: flex-end;
  margin-left: auto;

  &:active,
  &:focus {
    outline: 0;
  }
`

export const RemoveAllFilters = styled('button')`
  border: 0;
  padding: 0;
  background: transparent;

  &:active,
  &:focus {
    outline: 0;
  }
`

export const CloseButton = styled('button')`
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  align-items: center;
  color: ${({ theme }) => theme.colors.primary.normal};
  &:active,
  &:focus {
    outline: 0;
  }
`

const Filter = `
  border: 0px;
  box-shadow: 0px;
  padding: 0px 12px;
  margin: 0px 0px 12px;
  width: 100%;
  border-radius: 8px;
  background-color: #F5F5F5;
  font-size: 14px;
  height: 44px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;

  &:active, 
  &:focus {
    outline: 0; 
  }
`

export const ActiveFilterTag = styled('li')`
  margin: 0px 8px 12px 0px;
  max-width: 100%;
`

export const ActiveFilter = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 24px;
  min-width: 76px;
  max-width: inherit;
  padding: 4px 4px 4px 6px;
  font-weight: 600;
  border-radius: 4px;
  font-size: 12px;
  line-height: 16px;
  color: white;
  background-color: ${({ theme }) => theme.colors.secondary.normal};
`

export const FilterName = styled('p')`
  margin: 0px 8px 2px 0px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`

export const IdleFilter = styled('button')`
  ${Filter}
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: ${({ theme }) => theme.colors.grey84};
`

export const DisabledFilter = styled('div')`
  ${Filter}
  color: ${({ theme }) => theme.colors.grey36};
`

export const Facet = styled('button')`
  border: 0px;
  box-shadow: none;
  padding: 0px;
  margin: 0px;
  width: 100%;
  background-color: transparent;
  color: rgba(0, 0, 24, 0.6);
  font-size: 14px;
  line-height: 20px;
  height: 44px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  text-align: left;

  &:active,
  &:focus {
    outline: 0;
  }
`

export const FilterIcon = styled(Icon)`
  margin-right: 8px;
`

export const EmptySearchText = styled.div`
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.grey48};
  text-align: center;
`

export const LabelContainer = styled.div`
  display: flex;
  align-items: center;
`
